import React from 'react';
import './dailyTransaction.css';
// import Breadcrumb from '../../../components/Breadcrumb';
import { Outlet } from 'react-router-dom';

function DailyTransaction() {
  // const breadcrumbItems = [
  //   { label: 'Dashboard', href: '/' },
  //   { label: 'Daily Transaction' },
  // ];
  return (
    <div>
      <Outlet></Outlet>
    </div>
  );
}

export default DailyTransaction;
